module.exports = __webpack_public_path__ + "img/logo-vna.e7b5cb3f.svg";